import React from 'react'
import { Link } from 'react-router-dom'

export default function DynamicInfra({ data, extraClass = "" }) {
    if (!data) return null;

    return (
        <section className={`industries-excellence ${extraClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-5">
                        <div className="excellence-left">
                           <span className="gradient-color"> {data?.section2_red_heading} </span>
                            <h2 className="heading" dangerouslySetInnerHTML={{ __html: data?.section2_main_heading }} />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-7">
                        <div className="wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                            <div className="excellence-right">
                               <div  dangerouslySetInnerHTML={{ __html: data?.section2_description }} ></div>
                                <div className="excellence-btn">
                                    <Link to={"/contact"} className="default-btn" > <span>Talk to Our Experts</span>  </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}



